module.exports = __webpack_public_path__ + "static/media/video16x9b.018e53c1.mp4";